module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "co-working"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _c('div', {
    staticClass: "body plans"
  }, [_c('ul', _vm._l((_vm.plans), function(plan) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(plan.title))]), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(plan.price))]), _c('span', {
      staticClass: "span"
    }, [_vm._v(_vm._s(plan.span))])])
  })), _c('a', {
    staticClass: "cta",
    attrs: {
      "href": "mailto:" + _vm.email
    }
  }, [_vm._v("Jetzt Buchen")]), _c('p', {
    staticClass: "info"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.info)
    }
  })])]), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5d784e4"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Co-Working.vue
// module id = 435
// module chunks = 1